/**
 * Feature Flag Configuration
 *
 * Keys: Feature names (camelCase)
 * Values: Boolean (true = enabled, false = disabled)
 *
 * Admin Override: Users with admin role always have access to all features
 */

export interface FeatureFlags {
  [featureName: string]: boolean;
}

export const features: FeatureFlags = {
  // =====================
  // COMMUNICATION FEATURES
  // =====================
  contacts: true,
  communicationBoard: true,
  boardBuilder: true,
  keyboard: true,
  aacKeyboard: true,
  translator: true,
  sendFlow: true,

  // =====================
  // AI FEATURES
  // =====================
  aiChat: false,

  // =====================
  // MEDIA FEATURES
  // =====================
  youtube: true,
  music: true,
  tv: false,
  radio: true,
  games: false,
  entertainment: true,

  // =====================
  // SMART HOME
  // =====================
  smartHome: false,

  // =====================
  // CONTROL METHODS
  // =====================
  eyeControl: true,
  headTracking: false,
  gazeTracking: false,
  mouthGestures: false,
  externalSwitch: true,
  voiceControl: false,

  // =====================
  // MONITORING & ALERTS
  // =====================
  nightMonitoring: false,
  caregiverConnect: true,
  helpAlert: true,
  emergency: true,

  // =====================
  // USER FEATURES
  // =====================
  voiceCloning: false,
  guide: true,
  settings: true,
  onboarding: true,
  twoFactorAuth: true,

  // =====================
  // SYSTEM FEATURES
  // =====================
  rest: true,
  time: true,
  volume: true,
  help: true,
  cookieSettings: true,

  // =====================
  // EDITOR FEATURES
  // =====================
  homeEditor: true,
  boardEditor: true,
  keyboardEditor: true,
  entertainmentEditor: true,
  actionBarEditor: true,
  phrasesEditor: true,

  // =====================
  // ANALYTICS & ADMIN
  // =====================
  analyticsPanel: true,
  apiDocs: true,

  // =====================
  // LEGAL & INFO
  // =====================
  pricing: true,
  legal: true,
};

// Admin roles are now managed via the user_roles database table
// Use the is_admin() database function for server-side validation
